import { combineEpics } from 'redux-observable';
import type { Action } from '../state/actions';
import type { State } from '../state/types';
import appEpic from './app';
import estimationConfigEpic from './estimation-config';
import timeTrackingOptionsEpic from './time-tracking-options';
import { velocityDataFetchEpic } from './velocity-data-fetch';

export default combineEpics<Action, State>(
	appEpic,
	estimationConfigEpic,
	timeTrackingOptionsEpic,
	velocityDataFetchEpic,
);
